import { useState, useMemo } from "react";
import "../App.css";
import { BaseAddress } from "../projConst";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ReportIcon from "@material-ui/icons/Report";
import { makeStyles } from "@material-ui/core/styles";
import { width } from "@material-ui/system";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    textAlign: "left",
    backgroundColor: "#3f51b5",
    height: "40px",
    width: "100%"
  },
  content: {
    paddingLeft: theme.spacing.unit * 3
  },
  title: {
    // paddingLeft: theme.spacing.unit*3,
    textAlign: "left",
    color: "#000",
    backgroundColor: "#d9d9d9",
    fontSize: "75%"
  }
}));

const ShowAppFooter = props => {
  const classes = useStyles();

  const ShowViewmode = () => {
    const { viewmode } = props;
    return <span></span>;
  };

  return (
    <footer className="App-footer">
      <div className="App-header-1" ref={props.goToLog}>
        {/*props.config.children && props.config.children[0] &&
          <ListIcons icons={props.config.children[0].icons} iconsapp={props.iconsapp} access={ComputedAccess} handleOnClick={headerClick} />*/}
        <span className="component_app_title">
          {props.nameNsi}{" "}
          {/*<span className="component_app_description">{props.title}*/}
        </span>
      </div>
      <div className="App-footer-2">
        <h4 style={{ position: "absolute", top: 20 }}></h4>
      </div>
      <div className="App-footer-3">
        <div className="user_initial"> </div>
        {/*props.config.children && props.config.children[2] &&
        <ListIcons icons={props.config.children[2].icons} iconsapp={props.iconsapp} access={{ "avatar": 1 }} nodiv={true} handleOnClick={headerClick} /> */}
      </div>
    </footer>
  );
};
export default ShowAppFooter;
